<script setup lang="ts">

import useVuelidate from "@vuelidate/core";
import {computed} from "vue";

const props = defineProps({
  lazy: {
    type: Boolean,
    default: true,
  },
})

const v$ = useVuelidate({}, {}, {$scope: 'form', $lazy: props.lazy});

const isValid = computed(() => {
  return v$.value.$anyDirty ? !v$.value.$invalid : null;
});

const errors = computed(() => v$.value.$errors.map(e => e.$message));

const error = computed(() => errors.value[0] ?? '');

</script>
<template>
  <slot :is-valid="isValid"
        :errors="errors"
        :error="error">
  </slot>
</template>
